import { formatDuration, intervalToDuration } from 'date-fns';
import { FC } from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { Image } from '../atom/Image';
import { TokenUnit } from '../atom/TokenUnit';
import { ExchangeOrder, OrderData } from '@/constants/types';
import { getOrderInfo } from '@/components/exchange/orders/Order';

export interface FulfillPathProps {
    order: ExchangeOrder;
    orderData: OrderData;
    info: ReturnType<typeof getOrderInfo>;
    unstakingTime?: number;
}

export const FulfillPath: FC<FulfillPathProps> = ({ order, orderData, unstakingTime, info }) => {
    // TODO revise duration with unbond estimation
    const duration = intervalToDuration({
        start: new Date(),
        end: new Date().getTime() + unstakingTime! * 1000,
    });
    return !info ? null : (
        <div className="flex items-center justify-around border-[1px] border-grey-50 p-3 rounded-lg">
            <div className="flex flex-col space-y-1">
                <div className="flex space-x-1 text-white">
                    <Image isIcon asset={info!.primary?.tokenAsset!} height={20} width={20} />
                    <div className="t__heading--h6">
                        <TokenUnit value={orderData.amount} />
                    </div>
                </div>
                <span className="text-grey-30 t__caption--c1">You Deposit</span>
            </div>
            <AiOutlineArrowRight size={'16px'} />
            {orderData.startUnstaking && (
                <div className="flex items-center space-x-4">
                    <div className="flex flex-col items-center space-y-1">
                        <div className="flex space-x-1 text-white">
                            <Image isIcon asset={info.token?.tokenAsset!} height={20} width={20} />
                            <div className="t__heading--h6">
                                <TokenUnit value={orderData.amountLiquidToken} />
                            </div>
                        </div>
                        {unstakingTime ? (
                            <span className="text-grey-30 t__caption--c1">
                                Ready in{' '}
                                {formatDuration(duration, {
                                    format: duration?.days && duration.days > 0 ? ['days'] : ['hours'],
                                })}
                            </span>
                        ) : (
                            <span className="text-grey-30 t__caption--c1">Start Unbonding</span>
                        )}
                    </div>
                    <AiOutlineArrowRight size={'16px'} />
                </div>
            )}
            <div className="flex flex-col space-y-1">
                <div className="flex space-x-1 text-white">
                    <Image
                        isIcon
                        asset={
                            order.startTime > 0 || orderData.startUnstaking
                                ? info.primary!.tokenAsset
                                : info.token!.tokenAsset
                        }
                        height={20}
                        width={20}
                    />
                    <div className="t__heading--h6">
                        <TokenUnit
                            value={
                                orderData.startUnstaking ? orderData.amountTokenReceived : orderData.amountLiquidToken
                            }
                        />
                    </div>
                </div>
                <span className="text-grey-30 t__caption--c1">
                    You Get {orderData.startUnstaking ? info.primary?.tokenName : info.token?.tokenName}
                </span>
            </div>
        </div>
    );
};
